import { useSelector } from "react-redux";
import { ReduxRootState } from "types/redux-store";
import { selectAccountById, selectAllAccounts } from "./table";

export function useAccount(id: string) {
  return useSelector((state: ReduxRootState) => selectAccountById(state, id));
}

export function useAllAccounts() {
  return useSelector((state: ReduxRootState) => selectAllAccounts(state));
}
